const questions = [
  {
    summary: "How will you optimize our site speed?",
    details:
      "There is a log of apps only utilized on the footer being loaded on the top of the page. We delay these app scripts and prioritize the important ones. We clean up your code. If multiple developers have worked on your store over the years chances are they each are importing their own heavy code libraries. We clean all that up.",
  },
  {
    summary: "What guarantees do you provide?",
    details:
      "We guarantee to make all changes as mentioned at the plans with a money back guarantee as we will gladly provide one on a case-by-case basis before we start working.",
  },
  {
    summary: "Will my website be down during your clean-up?",
    details:
      "No, our experts will make sure that your website is constantly up and running without harming your sales and regular functioning.",
  },
  {
    summary: "Once completed will my website stay fast forever?",
    details:
      "This depends on the level of modifications you apply to your store, it will slow down over time, just as with your physical store regular cleanups of your codebase are considered good practice. ",
  },
];
export default questions;
